import React from 'react';
import { Card, Col, Row } from 'antd';
import { SignatureOutlined, DesktopOutlined, ControlOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const ContentCards = () => {
    const navigate = useNavigate();

    const cards = [
        {
            key: 'entry',
            icon: <SignatureOutlined style={{ fontSize: '48px' }} />,
            label: 'Bucket Pull Entry',
            route: '/entry',
            info: 'Print barcoded bucket pull strips and register bucket pull entries'
        },
        {
            key: 'screen',
            icon: <DesktopOutlined style={{ fontSize: '48px' }} />,
            label: 'Bar Screen',
            route: '/screen',
            info: 'Display bucket pulls and other information on a digital screen at the bar across the street'
        },
        {
            key: 'producer',
            icon: <ControlOutlined style={{ fontSize: '48px' }} />,
            label: 'Show Control',
            route: '/producer',
            info: 'This is for hosts and producers to scan bucket pulls, time sets, and control the digital signage'
        }
    ];

    const handleNavigate = (route) => {
        navigate(route);
    };

    return (
        <div style={{ paddingTop: '100px' }}>
            <Row gutter={[16, 24]} justify="center">
                {cards.map(card => (
                    <Col key={card.key} xs={24} sm={12} md={8} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <Card
                            hoverable
                            style={{
                                width: 240,
                                textAlign: 'center',
                                backgroundColor: '#FEC301',
                                marginBottom: '10px'
                            }}
                            onClick={() => handleNavigate(card.route)}
                        >
                            <div style={{ padding: '10px' }}>{card.icon}</div>
                            <Card.Meta
                                title={<span style={{ fontSize: '24px' }}>{card.label}</span>}
                            />
                        </Card>
                        <div style={{
                            color: 'white',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '10px',
                            width: '240px',
                            textAlign: 'center'
                        }}>
                            <InfoCircleOutlined style={{ marginRight: '5px' }} />
                            <span>{card.info}</span>
                        </div>
                    </Col>
                ))}
            </Row>
        </div>
    );
};

export default ContentCards;